import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // 导入路由器
import store from './store'; // 导入 Vuex store

createApp(App)
    .use(store) // 使用 Vuex store
    .use(router) // 使用 Vuex store
    .mount('#app');
